import { UISDK } from "@/ui-sdk";
import { CDN_URL } from "@/constants/cdn";

export async function handleCollectionFilters(
  element: HTMLElement,
  sdk: UISDK,
) {
  const collectionName = window.location.pathname.split("/").at(-1);
  const orgId = window?.helium?.brandData?.orgId;

  const collectionUrl = `${CDN_URL}/${orgId}/collections/${collectionName}/collection-filters.json`;
  try {
    const collectionData = await fetch(collectionUrl).then((r) => r.json());
    console.info("Collection data fetched:", collectionData);

    const filterData = collectionData;
    return sdk.renderCollectionFilters(element, filterData);
  } catch (error) {
    console.error("Error fetching collection filters:", error);
  }
}
